export default {
  language: 'fa',
  nameApp: 'fantasy',
  button: {
    rules: 'pantasy rules'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js